import classNames from 'classnames';
import { PdfViewerPresets } from 'common/pdf-viewer/pdf-viewer.presets';
import { PdfViewerProps } from 'common/pdf-viewer/pdf-viewer.types';
import React, { FC } from 'react';
import { Preview } from 'common/pdf-viewer/preview';
import { Sidebar } from './sidebar';
import { PdfViewerProvider, PdfViewerConsumer } from './hooks';

import styles from './pdf-viewer.module.scss';

export const PdfViewer: FC<PdfViewerProps> = props => {
  const { children, elements, onDelete } = props;

  return (
    <PdfViewerProvider elements={elements}>
      <div className="flex flex-col h-full w-full">
        <div className="p-4 bg-gray-50 flex justify-between items-center">
          <span>DOCUMENTOS ({elements?.length || 0})</span>
          {children}
        </div>
        <div className={classNames(styles.container)}>
          <Sidebar onDelete={onDelete} />
          <div className={classNames('bg-gray-300 flex-1', styles.preview)}>
            <PdfViewerConsumer>{state => <Preview url={state.elementSelected?.url} />}</PdfViewerConsumer>
          </div>
        </div>
      </div>
    </PdfViewerProvider>
  );
};

PdfViewer.defaultProps = PdfViewerPresets;
